export default __webpack_public_path__ + "static/media/61.8da36e94.jpeg";